import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLayoffAccess } from './useLayoff';

/**
 * Left nav entry for the lay-off tracker: users with a lay-off permission, and Payroll
 * (an email on the lay-off Payroll list), who has no permission but reviews and signs off
 */
const LayoffNavItem = ({ hasPermission, onClick }) => {
  const { data: access } = useLayoffAccess(!hasPermission);

  if (!hasPermission && !access?.review) {
    return null;
  }

  return (
    <li>
      <NavLink
        to='/layoff'
        activeClassName='active'
        isActive={(match, location) =>
          location.pathname.startsWith('/layoff') &&
          !location.pathname.startsWith('/layoff/sign')
        }
        onClick={onClick}
      >
        Layoff
      </NavLink>
    </li>
  );
};

export default LayoffNavItem;
